import { Component, OnInit } from '@angular/core';
import { SecurityPermissionName } from '@app/core/models/permission';
import { PortalError } from '@app/utils/error/portal-error';
import { SystemInfoViewModel } from '@business/system/models/system-info-view-model';
import { SystemService } from '@business/system/system.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'portal-system-info',
  templateUrl: './system-info.component.html',
  styles: [],
  standalone: false,
})
export class SystemInfoComponent implements OnInit {
  error$!: Observable<PortalError | null>;
  loading$!: Observable<boolean>;
  viewModel$!: Observable<SystemInfoViewModel>;

  Permission = SecurityPermissionName;

  constructor(private systemService: SystemService) {}

  ngOnInit(): void {
    this.error$ = this.systemService.systemInfo.error$.pipe(untilDestroyed(this));
    this.loading$ = this.systemService.systemInfo.loading$.pipe(delay(0), untilDestroyed(this));
    this.viewModel$ = this.systemService.systemInfo.data$.pipe(untilDestroyed(this));
  }
}
